module.exports = __webpack_public_path__ + "img/logo-vinaphone.6e074d71.png";